import { axiosClientv1 } from "./apiClient";
import { ApiResponse, MasterProductVariant } from "../Types";

export const GetVariants = async (): Promise<ApiResponse<MasterProductVariant[]>> => {
  try {
    const response = await axiosClientv1.get(`/variants`);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load product variants.",
      data: [],
      error: { code: error?.response?.status || 500, type: "server_error" },
    };
  }
};

export const SaveVariant = async (
  payload: { id?: string; variant_name: string; variant_types: any[] }
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/variants/save`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to save product variant.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};

export const DeleteVariant = async (
  id: string
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/variants/delete`, { id });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete product variant.",
      error: { code: error?.response?.status || 400, type: "bad_request" },
    };
  }
};